import { router } from 'expo-router'
import { useCallback } from 'react'

import Alert from '@/components/shared/Alert'
import FosterService from '@/services/fosterService'

interface Props {
  fosterId: string
}

const useDeleteAction = ({ fosterId }: Props) => {
  const { deleteFoster: fosterServiceDelete, isDeleting } =
    FosterService.useDeleteFoster(fosterId)

  const deleteFoster = useCallback(() => {
    Alert.alert(
      'Delete',
      'Are you sure you want to delete this foster? This will delete anything related to this foster including:\n\n- medical information\n- notes\n- documents\n- adoption records\n- microchip ID\n\nThis cannot be undone!',
      [
        {
          text: 'Cancel',
          onPress: () => console.log('Cancel Pressed'),
          style: 'cancel',
        },
        {
          isPreferred: false,
          text: 'Delete',
          onPress: async () => {
            await fosterServiceDelete()
            router.back()
          },
          style: 'destructive',
        },
      ]
    )
  }, [fosterServiceDelete])

  return { deleteFoster, isDeleting }
}

export default useDeleteAction
